import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./styles.module.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ProcessosInternos = ({ isProtected, path, name }) => {
  const [numPages, setNumPages] = useState(null);
  const [protect, setProtect] = useState(false);
  const [pdfError, setPdfError] = useState(false);
  const [filePath, setFilePath] = useState(path);
  const [pdfLoaded, setPdfLoaded] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPdfError(false);
    setPdfLoaded(true);
    setNumPages(numPages);
  };

  const activateProtection = () => {
    if (isProtected && pdfLoaded) {
      setProtect(true);
    }
  };

  useEffect(() => {
    setFilePath(path);
    setPdfError(false);
    setPdfLoaded(false);
  }, [path]);

  useEffect(() => {
    if (!pdfLoaded || !isProtected) return;

    const blockShortcuts = (e) => {
      const key = e.key.toLowerCase();
      if (
        key === "printscreen" ||
        (e.ctrlKey && ["p", "s", "c", "u"].includes(key)) ||
        e.metaKey ||
        e.key === "F12"
      ) {
        e.preventDefault();
        activateProtection();
        const overlay = document.createElement("div");
        overlay.id = "printscreen-blocker";
        Object.assign(overlay.style, {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#000",
          zIndex: "999999",
          pointerEvents: "none",
        });
        document.body.appendChild(overlay);
        setTimeout(() => {
          const el = document.getElementById("printscreen-blocker");
          if (el) el.remove();
        }, 800);
        try {
          navigator.clipboard.writeText(" ");
        } catch {}
      }
    };

    const blockContextMenu = (e) => {
      e.preventDefault();
      activateProtection();
    };

    const blockCopy = (e) => {
      e.preventDefault();
      activateProtection();
    };

    const blockSelection = (e) => {
      e.preventDefault();
    };

    const handleMouseLeave = () => {
      activateProtection();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        activateProtection();
      }
    };

    document.addEventListener("keydown", blockShortcuts);
    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("copy", blockCopy);
    document.addEventListener("selectstart", blockSelection);
    document.addEventListener("dragstart", blockSelection);
    window.addEventListener("blur", handleMouseLeave);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("keydown", blockShortcuts);
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("copy", blockCopy);
      document.removeEventListener("selectstart", blockSelection);
      document.removeEventListener("dragstart", blockSelection);
      window.removeEventListener("blur", handleMouseLeave);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isProtected, pdfLoaded]);

  const ProtectionScreen = () => (
    <div className={styles.protectionScreen}>
      <div className={styles.protectionAlert}>
        <span className={styles.protectionIcon}>
          <LockIcon />
        </span>
        <h2>Proteção Ativada</h2>
        <p>
          Este arquivo é <strong>protegido</strong>. Para retornar à ele,{" "}
          <strong>clique</strong> no botão abaixo.
        </p>
        <Button
          onClick={() => {
            setProtect(false);
          }}
          className={styles.protectionBtn}
          variant="contained"
        >
          Voltar
        </Button>
      </div>
    </div>
  );

  const shouldShowMessage = !filePath || pdfError;

  return (
    <div className={styles.container}>
      {protect && <ProtectionScreen />}
      <div className={styles.pdfWrapper}>
        {shouldShowMessage ? (
          <div className={`${styles.container} ${styles.cardInfo}`}>
            Selecione um PDF no menu ao lado.
          </div>
        ) : (
          <>
            <h3 className={`${styles.container} ${styles.cardInfo}`}>{name}</h3>
            <div className={styles.pdfContainer}>
              <Document
                file={filePath}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={() => setPdfError(true)}
              >
                {Array.from({ length: numPages }, (_, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                  />
                ))}
              </Document>
              <div className={styles.overlay} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProcessosInternos;
